module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0051.jpg?v=b5073443";